import React, { useState } from "react";
import { money } from "./fields";
import { YearTable } from "./YearTable";

const METRICS = [
  ["annual_net_income", "Annual after-tax income", true],
  ["income_years", "Years of income", false],
  ["total_net_income", "Total after-tax income", true],
  ["total_taxes", "Estimated taxes paid", true],
  ["liquidity_year1", "Liquidity: year-1 value", true],
  ["value_at_income_start", "Value at income start", true],
  ["legacy_at_plan_age", "Legacy (after tax to heirs)", true],
];

const Bar = ({ v, max }) => <div className="h-1 bg-exodus-border mt-2"><div className="h-1 bg-exodus-gold transition-all duration-500" style={{ width: `${max ? Math.max(2, (v / max) * 100) : 0}%` }} /></div>;

export const StepCompare = ({ result, product }) => {
  const [detail, setDetail] = useState(null);
  const cmp = result.compare;
  return (
    <div className="space-y-8">
      <div data-testid="ro-compare" className="border border-exodus-border overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-exodus-elevated">
            <tr>
              <th className="p-4 text-left text-[10px] eyebrow text-exodus-muted font-normal w-1/4">Through age {result.client.plan_to_age}</th>
              {cmp.map((x) => (
                <th key={x.key} data-testid={`ro-compare-col-${x.key}`} className={`p-4 text-left font-display text-lg font-normal ${x.key === product ? "gold-text" : ""}`}>{x.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {METRICS.map(([k, label, isMoney]) => {
              const max = Math.max(...cmp.map((x) => x[k]));
              return (
                <tr key={k} className="border-t border-exodus-border">
                  <td className="p-4 text-xs text-exodus-muted">{label}</td>
                  {cmp.map((x) => (
                    <td key={x.key} data-testid={`ro-compare-${x.key}-${k}`} className="p-4 font-mono">
                      {isMoney ? money(x[k]) : x[k]}
                      {k !== "total_taxes" && <Bar v={x[k]} max={max} />}
                    </td>
                  ))}
                </tr>
              );
            })}
            <tr className="border-t border-exodus-border"><td className="p-4 text-xs text-exodus-muted">Liquidity</td>{cmp.map((x) => <td key={x.key} className="p-4 text-xs">{x.liquidity_note}</td>)}</tr>
            <tr className="border-t border-exodus-border"><td className="p-4 text-xs text-exodus-muted">Downside protection</td>{cmp.map((x) => <td key={x.key} className="p-4 text-xs">{x.protection}</td>)}</tr>
          </tbody>
        </table>
      </div>
      <p className="text-xs text-exodus-muted leading-relaxed">
        "Keep" uses the qualified-account return and fees you set. Pre-tax withdrawals are taxed at your combined rate, and heirs' legacy is shown after the same rate. The IUL legacy is the death benefit net of loans (generally income-tax-free).
      </p>
      <div className="flex flex-wrap gap-2">
        {cmp.map((x) => (
          <button key={x.key} type="button" data-testid={`ro-compare-detail-${x.key}`} onClick={() => setDetail(detail === x.key ? null : x.key)}
            className={`text-xs px-3 py-2 border transition-colors ${detail === x.key ? "border-exodus-gold text-exodus-gold" : "border-exodus-border text-exodus-muted hover:border-exodus-gold"}`}>
            {detail === x.key ? "Hide" : "Show"} {x.label} year by year
          </button>
        ))}
      </div>
      {detail && (
        <YearTable testid={`ro-compare-table-${detail}`} kind={detail} incomeStart={result.client.income_start_age}
          rows={detail === "keep" ? result.qualified.rows : result[detail].rows} />
      )}
    </div>
  );
};
